<template>
  <div>
    <van-field v-model="selectValue" :placeholder="placeholder" type="text" :label="label" is-link readonly
      @focus="onFocus" :required="required" :rules="[{ required: required, message: label+'不能为空'}]" />
    <div class="van-hairline--bottom"></div>
    <van-action-sheet v-model="show" name="abc" :title="title">
      <van-search v-model="search" placeholder="请输入" @input="OnInput"></van-search>
      <van-cell v-for="(item,index) in filterList" :key="index" :title="item[labelProp]" @click="onSelect(item)">
        <template #right-icon>
          <van-tag type="primary" v-if="selectList.indexOf(item[labelProp])!=-1">已选</van-tag>
        </template>
      </van-cell>
    </van-action-sheet>
  </div>
</template>

<script>
  export default {
    name: "StaticMulSelect",
    data() {
      return {
        selectValue: this.value,
        show: false,
        options: [],
        search: "",
        // 已选中的数组
        selectList: []
      };
    },
    props: {
      label: {
        type: String,
        default: "",
      },
      placeholder: {
        type: String,
        default: "请选择",
      },
      title: {
        type: String,
        default: "请选择",
      },
      // 是否必填
      required: {
        type: Boolean,
        default: false
      },
      value: {
        default: "",
      },
      selectkey: {},
      // 选项默认label属性
      labelProp: {
        type: String,
        default: "name"
      },
      // 选项默认value属性
      valueProp: {
        type: String,
        default: "id"
      },
      //传递进来的默认数组,
      //默认数据格式为{id:1,name:"111"}
      list: {
        type: Array,
        default: function() {
          return []
        }
      },
    },
    computed: {
      filterList() {
        let that = this
        // let filterList = []
        // that.options.forEach(function(item){
        //   if(typeof(item[that.labelProp]) == "number"){
        //     console.log(item[that.labelProp]);
        //   }
        // })
        return that.options.filter(m => m[that.labelProp] && m[that.labelProp].toString().indexOf(that.search) != -1)
      }
    },

    watch: {
      value(newVal) {
        this.selectValue = newVal;
      },
      selectkey() {
        let that = this
        // 获得选中的label数据
        that.selectValue = that.getSelectValue(that.selectkey)
      },
      list(newVal) {
        let that = this
        this.options = this.$utils.clone(newVal)
        // 获得选中的label数据
        that.selectValue = that.getSelectValue(that.selectkey)
      }
    },
    methods: {
      // 展示选项
      onFocus: function() {
        this.show = true;
      },
      //搜索框变化事件
      OnInput: function() {
        //this.LoadItem()
      },
      onSelect: function(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        let that = this
        // 获得当前行的value值
        let valueNow = item[that.valueProp]
        // 判断当前点击对象是否已经选中了
        if (that.selectList.indexOf(valueNow) == -1) {
          // 未选中行,将当前行的value值推入选中数组
          that.selectList.push(valueNow)
        } else {
          // 选中行，将当前行索引剔除
          let selectIndex = that.selectList.indexOf(valueNow)
          that.selectList.splice(selectIndex, 1)
        }

        // 当前选中value值的 , 隔开数据，提交给外部
        let vauleSubmit = that.selectList.toString()

        that.selectValue = that.getSelectValue(vauleSubmit)
        console.log(that.selectList);
        // this.selectValue = item[that.labelProp];
        this.$emit("input", that.selectValue);
        this.$emit("update:selectkey", vauleSubmit);

      },
      LoadData: function() {
        let that = this
        this.options = this.$utils.clone(this.list)
        if (that.selectkey) {
          // 获得选中的label数据
          that.selectValue = that.getSelectValue(that.selectkey)
        }
      },
      // 根据数组和选中的值,获得对应的label文本
      getSelectValue(selectkey) {
        let that = this
        let nameValue = ""
        // selectkey 有值，进行分割和获得label操作
        if (selectkey) {
          // 获得分割的数组
          that.selectList = selectkey.split(",")
          // 过滤出已经选中的数据
          let filterList = that.options.filter(m => that.selectList.indexOf(m[that.valueProp]) != -1)
          if (filterList.length > 0) {
            nameValue = filterList.map(item => item[that.labelProp]).toString()
          }
          return nameValue
        } else {
          // selectkey为空，直接返回""
          return ""
        }


      }
    },
    mounted: function() {

      this.LoadData();
    },
  };
</script>

<style>
</style>
